<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan" v-if="!$store.getters.cusId">
          <el-form-item :label="$t('billingPage.CustomerName')">
            <BjSelectLov v-model="queryParams.clientCode" :option-list="clientCodeList" :placeholder="$t('billingPage.CustomerName')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderToBeApproved.SKU')" prop="sku">
            <BjInput v-model="queryParams.sku" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('SalesOrderToBeApproved.SKU')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 退货单号 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessAfterCsgReturn.main.outRefundNo')" prop="outRefundNo">
            <BjInput v-model="queryParams.outRefundNo" :placeholder="$t('BusinessAfterCsgReturn.main.outRefundNo')" comma @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 关联单号 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.common.associatedCode')" prop="associatedCode">
            <BjInput v-model="queryParams.associatedCode" :placeholder="$t('CustomerFunction.common.associatedCode')" comma @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')">
            <BjDateRangePicker v-model="queryParamsTime_pay" :placeholder="$t('table.createTimeText')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.endDate')">
            <BjDateRangePicker v-model="queryParamsUpdateTime_pay" :placeholder="$t('billingPage.endDate')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'status'">{{$t(CSG_RETURN_LIST_ADMIN_CLOSE.bjGet(scope.row[col.prop])) }}</template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onDetail(props.row)">{{$t('viewText')}}</el-button>
                <el-button :disabled="!props.row.canConfirm" type="text" class="edit-btn" @click="onConfirm(props.row)">{{ $t('okText')}}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="title" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
      <el-form ref="form" :model="form" status-icon :rules="rules" label-width="120px" :disabled="disabled">
        <el-form-item :label="$t('serviceItem.table.name')" prop="name">
          <BjInput :maxlength="20" :placeholder="$t('inputText')" />
        </el-form-item>
        <el-form-item :label="$t('serviceItem.table.Serialnumber')" prop="name">
          <BjInput :maxlength="20" :placeholder="$t('inputText')" />
        </el-form-item>
        <el-form-item :label="$t('serviceItem.table.timeConsuming')" prop="timeConsuming">
          <BjInput :maxlength="20" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="submitForm('form')">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { orderApi } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';
import {CSG_RETURN_LIST_ADMIN_CLOSE,} from '@/utils/constants';
export default {
    mixins: [pageMiXin],
    name: 'BusinessCloseReturnList',
    data() {
        return {
            CSG_RETURN_LIST_ADMIN_CLOSE,
            queryApi: orderApi.pageList,
            queryParamsTime_pay: [],
            queryParamsUpdateTime_pay: [],
            labelList: [
                { label: this.$t('customerNameText'), prop: 'customName', isCheck: true, disabled: false },
                { label: this.$t('BusinessAfterCsgReturn.main.outRefundNo'), prop: 'outRefundNo', isCheck: true, disabled: false, width: '170' },
                { label: this.$t('CustomerFunction.common.logisticsNo'), prop: 'logisticsNumber', isCheck: true, disabled: false, },
                { label: this.$t('CustomerFunction.common.associatedCode'), prop: 'associatedCode', isCheck: true, disabled: false },
                { label: this.$t('table.createTimeText'), prop: 'applyDate', isCheck: true, disabled: false },
                { label: this.$t('billingPage.endDate'), prop: 'auditDate', isCheck: true, disabled: false },
                { label: this.$t('table.statusText'), prop: 'status', isCheck: true, disabled: false },
                { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
            ],
            queryParams: {
                tenantId: null,
                customName: null,
                clientCode: this.$store.getters.userInfo.clientCode || null,
                status: 3,
                creationDateStart: null,
                creationDateEnd: null,
                auditDateStart: null,
                auditDateEnd: null,
                outRefundNo: null,
                associatedCode: null,
                sku: null,
            },
            dialogVisible: false,
            disabled: false
        };
    },
    watch: {
        queryParamsTime_pay(v) {
            this.queryParams.creationDateStart = (v || [])[0];
            this.queryParams.creationDateEnd = (v || [])[1];
        },
        queryParamsUpdateTime_pay(v) {
            this.queryParams.auditDateStart = (v || [])[0];
            this.queryParams.auditDateEnd = (v || [])[1];
        }
    },
    methods: {
        onConfirm(row) {
            const { id } = row;
            this.$toPage('BusinessAfterReturnConfim', { id });
        },
        beforeResetSearch() {
            this.queryParamsTime_pay = null;
            this.queryParams.clientCode = null;
            this.queryParams.status = 3;
            this.queryParamsUpdateTime_pay = null;
            this.queryParams.clientCode = this.$store.getters.userInfo.clientCode || null
            return new Promise(resolve => {
                resolve();
            });
        },
        onDetail(row) {
            const { id } = row;
            this.$toPage('BusinessAfterReturnView', { id });
        },
    }
};
</script>

<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>